import { render, staticRenderFns } from "./MCardCol4.vue?vue&type=template&id=4320fe60&scoped=true&"
import script from "./MCardCol4.vue?vue&type=script&lang=js&"
export * from "./MCardCol4.vue?vue&type=script&lang=js&"
import style0 from "./MCardCol4.vue?vue&type=style&index=0&id=4320fe60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4320fe60",
  null
  
)

export default component.exports